import CloseIcon from "@mui/icons-material/Close";
import { Document, Page, pdfjs } from "react-pdf";

import { IconButton } from "../atoms/IconButton";
import { Image } from "../atoms/Image";
import { List } from "../molecules/List";

pdfjs.GlobalWorkerOptions.workerSrc =
  process.env.NEXT_PUBLIC_APP_ENV === "production"
    ? `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`
    : `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface Props {
  files: FileList;
  onRemove: (index: number) => void;
}

export const FilePreview = ({ files: fileList, onRemove }: Props) => {
  const files = Array.from(fileList);

  const handleRemove = (index: number) => {
    if (onRemove) onRemove(index);
  };

  return (
    <List
      tw="bg-white mb-0! py-4 border-t border-solid border-gray"
      data={files}
      columns={4}
      renderItem={(data, index: number) => (
        <div tw="flex">
          <div tw="w-20 h-20 mx-auto">
            <div tw="relative">
              <div tw="w-20 h-20 border border-solid border-gray">
                {data.type === "application/pdf" ? (
                  <Document file={data}>
                    <Page pageNumber={1} width={80} height={80} />
                  </Document>
                ) : (
                  <Image
                    src={URL.createObjectURL(data)}
                    height={80}
                    width={80}
                    layout="responsive"
                    objectFit="cover"
                    tw="rounded-md"
                  />
                )}
              </div>
              <IconButton
                tw="absolute -top-2 -right-2 bg-gray rounded-full"
                icon={<CloseIcon tw="text-black text-opacity-60 text-xl" />}
                onClick={() => handleRemove(index)}
              />
            </div>
          </div>
        </div>
      )}
      bottomBorder={false}
    />
  );
};
